































import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * Daftar baris teks bebas untuk blanko SKM (Diagnosis / Terapi / Obat).
 * Emit selalu berupa array baru supaya perubahan terdeteksi Vue 2.
 */
@Component
export default class SkmDaftarBaris extends Vue {
  @Prop({ default: () => [] }) readonly value!: Array<{ text: string }>;
  @Prop({ default: "" }) readonly label!: string;
  @Prop({ default: "" }) readonly placeholder!: string;
  @Prop({ type: Boolean, default: false }) readonly readonly!: boolean;

  get rows(): Array<{ text: string }> {
    return Array.isArray(this.value) ? this.value : [];
  }

  emit(rows: Array<{ text: string }>) {
    this.$emit("input", rows);
  }

  ubah(idx: number, teks: string) {
    const rows = this.rows.map((r, i) => (i === idx ? { ...r, text: teks } : r));

    this.emit(rows);
  }

  tambah() {
    this.emit(this.rows.concat([{ text: "" }]));
  }

  hapus(idx: number) {
    this.emit(this.rows.filter((r, i) => i !== idx));
  }
}
